import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import api from "../api/axiosInstance";
import "../App.css"; 
import contactImage from "../assets/contact.jpeg"; 
import Footer from "../components/Footer";
import { CheckCircle, AlertCircle, X } from "lucide-react";

const Contact = () => {
  const recaptchaRef = useRef(null);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      setToast({ type: "error", message: "Please verify you are not a robot!" });
      setTimeout(() => setToast({ type: "", message: "" }), 4000);
      return;
    }

    setLoading(true);
    try {
      const response = await api.post("https://www.api.teqnoor.info/api/v1/contact", {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        captchaToken: captchaToken 
      });

      if (response.data.success) {
        setToast({ type: "success", message: "Message sent successfully!" });
        setFormData({ name: "", email: "", message: "" });
        setCaptchaToken(null);
        recaptchaRef.current.reset();
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Something went wrong";
      setToast({ type: "error", message: errorMsg });
      if (recaptchaRef.current) recaptchaRef.current.reset();
      setCaptchaToken(null);
    } finally {
      setLoading(false);
      setTimeout(() => setToast({ type: "", message: "" }), 4000);
    }
  };

  return (
    <div className="calisthenics-page">
      <div className="calisthenics-banner" style={{ backgroundImage: `url(${contactImage})` }}>
        <div className="banner-overlay"></div>
        <h2>GET IN TOUCH</h2>
      </div>

      <div className="contact-section container mt-5">
        <h3 className="contact-heading">
          HAPPY TO HELP! LET ME KNOW <br /> YOUR QUESTIONS OR FEEDBACK
        </h3>

        <div className="contact-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="name-email-row">
              <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            </div>
            <textarea name="message" placeholder="Message" rows="5" value={formData.message} onChange={handleChange} required></textarea>

            <div className="captcha-container" style={{ marginBottom: "20px" }}>
                <ReCAPTCHA ref={recaptchaRef} sitekey="6LdCE2gsAAAAABrb4zHnPQ_YADOSZ49-8nQvgFJi" onChange={onCaptchaChange} />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>

          <div className="contact-info">
            <div className="info-box">
              <h4><i className="fas fa-phone"></i> Phone number</h4>
              <p>+259 (0) 256 215</p>
            </div>
            <div className="info-box">
              <h4><i className="fas fa-envelope"></i> Email address</h4>
              <p>contact@strongx.com</p>
            </div>
            <div className="info-box">
              <h4><i className="fas fa-map-marker-alt"></i> Address</h4>
              <p>123 Main Street, Cityville, Stateville, ZIP Code</p>
            </div>
          </div>
        </div>
      </div>

      {/* --- TOAST USING CSS CLASSES --- */}
      {toast.message && (
        <div className="premium-toast-container">
          <div className={`toast-icon-wrapper ${toast.type}`}>
            {toast.type === "success" ? (
              <CheckCircle size={24} color="#10b981" />
            ) : (
              <AlertCircle size={24} color="#ef4444" />
            )}
          </div>

          <div className="toast-content">
            <span className="toast-title">
              {toast.type === "success" ? "" : "Error"}
            </span>
            <span className="toast-message">{toast.message}</span>
          </div>

          <X className="toast-close-btn" size={18} onClick={() => setToast({ type: "", message: "" })} />
        </div>
      )}

      <Footer/>
    </div>
  );
};

export default Contact;